import { defineStore } from "pinia";

export const useUserStore = defineStore("user", {
  state: () => {
    let user = localStorage.getItem("user") || false;
    user = user ? JSON.parse(user) : {};
    return {
      user: user,
    };
  },
  actions: {
    setUser(user) {
      this.user = user;
      localStorage.setItem("user", JSON.stringify(user));
    },
  },
});
